import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  Chip,
  Button,
} from "@mui/material";
import { db, auth } from "../../../firebase-config";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const QuoteList = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const currentUser = auth.currentUser;

  useEffect(() => {
    if (!currentUser) return;

    const fetchQuotes = async () => {
      try {
        let q;
        const quotesRef = collection(db, "quotes");

        if (currentUser) {
          // Fetch quotes for the user and their company
          q = query(quotesRef, where("userId", "==", currentUser.uid));
        } else {
          q = query(quotesRef, where("userId", "==", currentUser.uid));
        }

        const snapshot = await getDocs(q);
        const quoteList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setQuotes(quoteList);
      } catch (err) {
        console.error("Error fetching quotes:", err);
        setError("Failed to load quotes.");
      } finally {
        setLoading(false);
      }
    };

    fetchQuotes();
  }, [currentUser]);

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Your Quotes
      </Typography>

      {quotes.length === 0 ? (
        <Typography>No quotes found.</Typography>
      ) : (
        <Box>
          {quotes.map((quote) => (
            <Card key={quote.id} sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6">
                  Quote ID: {quote.id}{" "}
                  <Chip
                    label={quote.status.toUpperCase()}
                    color={
                      quote.status === "pending"
                        ? "warning"
                        : quote.status === "approved"
                        ? "success"
                        : "error"
                    }
                    sx={{ ml: 1 }}
                  />
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Requested on: {new Date(quote.createdAt.toDate()).toLocaleString()}
                </Typography>

                <List sx={{ mt: 2 }}>
                  {/*quote.items.map((item, index) => (
                    <React.Fragment key={index}>
                      <ListItem>
                        <ListItemText
                          primary={item.name}
                          secondary={`Quantity: ${item.quantity} | Price: $${item.price.toFixed(2)}`}
                        />
                      </ListItem>
                      {index < quote.items.length - 1 && <Divider />}
                    </React.Fragment>
                  ))*/}
                </List>

                <Button
                  variant="outlined"
                  sx={{ mt: 2 }}
                  onClick={() => navigate(`/admin/quotes/${quote.id}`)}
                >
                  View Details
                </Button>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </Container>
  );
};

export default QuoteList;
